import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UrlService } from '../url/url.service';
import { Version } from '../../objects/version';
import { Message } from '../../objects/message';

@Injectable({
    providedIn: 'root'
})

export class MessagesService {

    constructor(public urlSrv: UrlService, public http: HttpClient){}

    // find(version: Version, urlPrefix: string = "") {
    //     return this.http.get(this.urlSrv.build(urlPrefix + "/versions/" + version.id+"/messages"));
    // }
    /**
     * 
     * @param message 
     * @param prefixUrl 
     * @param context should be dafault if the call use the url on the Appliication used, but if we want to call
     * /web/share on /app screen we neet to avoid use of url service. 
     * This is a FRONT context only associated with where service is called. not a Message object property
     * @returns subscriber to listen the response of delete call
     */
    remove(message: Message, prefixUrl: string = "",context: string = "" ) {
        return this.http.delete(this.getContextUrl(prefixUrl,context) +"/messages/"+message.id);
    }

    protected getContextUrl(prefix: string, context:string){
        // oct-2026: a prefix that is already a full url (e.g. "/web/share/p/feedback/{token}" for a recipient's
        // message on the artwork details page) must not be built again: when the caller's context came undefined
        // (the default "" applies), it became "/web/app/web/share/..." and the DELETE failed
        if (prefix?.startsWith('/web/') || prefix?.startsWith('http'))
            return prefix;
        return (context != "" && context != 'message-default') ? prefix : this.urlSrv.build(prefix);
    }

}
